import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Initial-Letter--Streamline-Flex"
    >
        <desc>
            {'Initial Letter Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="initial-letter">
            <path
                id="Vector 749"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.09865 2.23047h5.40125"
                strokeWidth={1}
            />
            <path
                id="Vector 750"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.09863 5.98706 5.40127 0"
                strokeWidth={1}
            />
            <path
                id="Vector 751"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 9.74341h12.9999"
                strokeWidth={1}
            />
            <path
                id="Vector 752"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 13.5h12.9999"
                strokeWidth={1}
            />
            <path
                id="Vector 2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.66748 5.98698C0.896055 4.84965 1.58593 0.5 2.95372 0.5c1.36779 0 2.05767 4.34965 2.28624 5.48698"
                strokeWidth={1}
            />
            <path
                id="Vector 3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.27734 4.15796H4.6305"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
